import React from 'react';
import { Briefcase, Flower2, HeartHandshake, PartyPopper, Sparkles, Users, UsersRound, Wind } from 'lucide-react';
import { FadeIn } from './FadeIn';
import { WhatsAppButton } from './WhatsAppButton';
const AUDIENCES = [{
  label: 'Retreats',
  icon: Sparkles
}, {
  label: 'Workshops',
  icon: HeartHandshake
}, {
  label: 'Corporate days',
  icon: Briefcase
}, {
  label: 'Yoga',
  icon: Flower2
}, {
  label: 'Breathwork',
  icon: Wind
}, {
  label: "Women's groups",
  icon: UsersRound
}, {
  label: 'Private events',
  icon: PartyPopper
}];
const SPACE_FEATURES = ['Dome', 'Sauna', 'Hot tub', 'Cold plunges', 'Pool', 'Outdoor kitchen', 'Fire pit', 'Accommodation'];
export function RetreatSpaceDetails() {
  return <section className="bg-cream px-6 py-20 md:px-12 md:py-32" data-id="element-493" data-mp="2rin3f1fvf5ej">
      <div className="mx-auto max-w-6xl" data-id="element-494" data-mp="lqgdprvrbytt">
        <div className="grid grid-cols-1 gap-16 lg:grid-cols-12 lg:gap-24" data-id="element-495" data-mp="lnama5znokux">
          <div className="lg:col-span-7" data-id="element-496" data-mp="pqgqz974e3za">
            <FadeIn data-id="element-497" data-mp="21xlnwchhroq6">
              <p className="mb-4 text-xs font-medium uppercase tracking-[0.2em] text-clay/70" data-id="element-498" data-mp="21wtsb1nw9qzw">
                Perfect for
              </p>
            </FadeIn>
            <FadeIn delay={0.1} data-id="element-499" data-mp="1wwo7o5g1l4rb">
              <h2 className="mb-8 font-serif text-4xl leading-tight text-pine md:text-5xl" data-id="element-500" data-mp="2bny5pwxx93sm">
                Meaningful experiences need a place that can hold them.
              </h2>
            </FadeIn>
            <div className="grid grid-cols-2 gap-3 sm:grid-cols-3" data-id="element-501" data-mp="1ixxz9tnrvinn">
              {AUDIENCES.map((audience, index) => {
              const Icon = audience.icon;
              return <FadeIn key={audience.label} delay={index * 0.05} data-id="element-502" data-mp="1sxgi26ry4ye4" data-mpi={index}>
                    <div className="flex h-full min-h-28 flex-col justify-between rounded-sm border border-pine/15 bg-creamDeep p-5" data-id="element-503" data-mp="1sukkwknxadqq">
                      <Icon className="h-5 w-5 text-ember" data-id="element-504" data-mp="34bav0evgvppm" />
                      <p className="mt-6 font-medium leading-snug text-pine" data-id="element-505" data-mp="34dx2keicy57u">
                        {audience.label}
                      </p>
                    </div>
                  </FadeIn>;
            })}
              <FadeIn delay={AUDIENCES.length * 0.05} data-id="element-506" data-mp="3ber3er7o8d3o">
                <div className="flex h-full min-h-28 flex-col justify-between rounded-sm border border-dashed border-pine/25 bg-cream p-5" data-id="element-507" data-mp="3bhdbcryh4umf">
                  <Users className="h-5 w-5 text-clay/50" data-id="element-508" data-mp="3ldzvtfmw1jnx" />
                  <p className="mt-6 text-sm font-light leading-snug text-clay/80" data-id="element-509" data-mp="3lbdn3co9gy44">
                    Something else in mind? Ask Zev.
                  </p>
                </div>
              </FadeIn>
            </div>
          </div>

          <div className="lg:col-span-5" data-id="element-510" data-mp="2xo5fup79vezg">
            <FadeIn data-id="element-511" data-mp="2xmay1jras2zl">
              <p className="mb-4 text-xs font-medium uppercase tracking-[0.2em] text-clay/70" data-id="element-512" data-mp="2xlssfwiqwcf0">
                Facilities
              </p>
            </FadeIn>
            <FadeIn delay={0.1} data-id="element-513" data-mp="24y5e2z82ii0t">
              <div className="border-t border-pine/15" data-id="element-514" data-mp="24x40amzo3hfe">
                {SPACE_FEATURES.map(feature => <div key={feature} className="flex items-center justify-between border-b border-pine/15 py-4" data-id="element-515" data-mp="29vyfleyfenur">
                    <span className="text-lg font-light text-clay" data-id="element-516" data-mp="n239c2d9mgrd">{feature}</span>
                    <span className="h-1.5 w-1.5 rounded-full bg-ember" data-id="element-517" data-mp="i177duch54ol" />
                  </div>)}
              </div>
            </FadeIn>
            <FadeIn delay={0.2} data-id="element-518" data-mp="84awjhz3s6gv">
              <div className="mt-8" data-id="element-519" data-mp="85cjokte8jey">
                <WhatsAppButton label="WhatsApp Zev" className="w-full sm:w-auto" data-id="element-520" data-mp="86f9sqiw6htt" />
                <p className="mt-4 text-sm font-light leading-relaxed text-clay/70" data-id="element-521" data-mp="3c1c2hgrbylz">
                  Tell Zev your dates and group size and he'll come back with
                  availability and pricing.
                </p>
              </div>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}